"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NewPackagesPage = void 0;
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importStar(require("react"));
var react_confirm_alert_1 = require("react-confirm-alert");
var react_redux_1 = require("react-redux");
var react_select_1 = __importDefault(require("react-select"));
require("react-confirm-alert/src/react-confirm-alert.css");
require("./NewPackagesPage.scss");
var NewPackages_1 = __importDefault(require("../components/NewPackages"));
var actions_1 = require("../state/actions");
var Page_1 = require("@app/components/layout/Page");
var actions_2 = require("@app/features/package-details/state/actions");
var PackageSearchInput_1 = require("@app/features/package-history/components/PackageSearchInput");
var selectors_1 = require("@app/features/transfers/state/selectors");
var config_1 = require("@app/shared/config");
var log_1 = __importDefault(require("@app/shared/log"));
var matomo_1 = require("@app/shared/matomo");
var initialState = {
    searchTerm: '',
    selectedWorkgroup: '',
    userActed: false
};
var NewPackagesPage = /** @class */ (function (_super) {
    __extends(NewPackagesPage, _super);
    function NewPackagesPage(props) {
        var _this = _super.call(this, props) || this;
        _this.state = initialState;
        /* Component Lifecycle Methods - End */
        /* Component Methods - Begin */
        _this.handleDismissAll = function () {
            if (_this.props.newPackagesSearchCount > 0) {
                new matomo_1.MatomoTracker().trackEvent('User', 'Clicked Move all to History');
                react_confirm_alert_1.confirmAlert({
                    title: 'Move all packages to History?',
                    message: 'All packages will be removed from your inbox, and permanently move into your history.',
                    buttons: [{
                            label: 'Yes, move all',
                            onClick: function () {
                                _this.props.onConfirmDismissAll();
                            }
                        }, {
                            label: 'No',
                            onClick: function () { return log_1.default.info("Dismissed 'Move all to History' confirmation"); }
                        }]
                });
            }
        };
        _this.handleSearchInputChange = function (searchTerm) {
            _this.props.saveSearchTerm(searchTerm);
            _this.setState({ searchTerm: searchTerm, userActed: true });
        };
        _this.handleViewingChange = function (selectedOption) {
            _this.setState(__assign(__assign({}, _this.state), { searchTerm: '', selectedWorkgroup: selectedOption.value }));
            new matomo_1.MatomoTracker().trackEvent('New Packages', 'Change Inbox View', selectedOption.label + " : " + selectedOption.value);
            _this.props.onResetSort();
        };
        if (_this.props.locationAction === 'REPLACE' || props.locationAction === 'POP') {
            _this.state = __assign(__assign({}, _this.state), { searchTerm: _this.props.savedSearchTerm ? _this.props.savedSearchTerm : '', selectedWorkgroup: _this.props.savedWorkgroupEmail ? _this.props.savedWorkgroupEmail : '' });
        }
        else {
            _this.state = __assign(__assign({}, _this.state), { searchTerm: '', selectedWorkgroup: '' });
        }
        return _this;
    }
    /* Component Lifecycle Methods - Begin */
    NewPackagesPage.prototype.componentDidUpdate = function (prevProps) {
        // When user first signs into Blast for the first time sometimes the package cache has not been built yet
        // In that case, wait for the cache to refresh, then get the user's new packages
        if (prevProps.isResetting !== this.props.isResetting && this.props.isResetting) {
            if (this.props.locationAction === 'REPLACE' || this.props.locationAction === 'POP') {
                this.setState({ searchTerm: this.props.savedSearchTerm ? this.props.savedSearchTerm : '' });
            }
            else {
                if (this.state.userActed) {
                    this.setState({ searchTerm: this.props.savedSearchTerm ? this.props.savedSearchTerm : '' });
                }
                else {
                    this.setState({ searchTerm: '', userActed: false });
                }
            }
        }
    };
    /* Component Methods - End */
    NewPackagesPage.prototype.render = function () {
        var _this = this;
        var _a = this.props, newPackagesCount = _a.newPackagesCount, newPackagesSearchCount = _a.newPackagesSearchCount, workgroups = _a.workgroups;
        var viewingOptions = [{ value: '', label: 'My Inbox' }];
        // Populate viewingOptions
        workgroups.map(function (w) {
            viewingOptions.push({
                value: w.user.email,
                label: w.user.email
            });
        });
        // Determine which dropdown option is already selected
        var getSelectedViewing = function () {
            var selectedOption = null;
            viewingOptions.forEach(function (option) {
                if (option.value === _this.state.selectedWorkgroup) {
                    selectedOption = option;
                }
            });
            return selectedOption;
        };
        return (react_1.default.createElement(Page_1.Page, { title: "New Packages", isAsperaInitializing: this.props.asperaInitializing, isLoading: !this.props.asperaLoaded },
            viewingOptions.length > 1 &&
                react_1.default.createElement("div", { id: "viewing-header", className: "level" },
                    react_1.default.createElement("div", { className: "level-item" },
                        react_1.default.createElement("label", { className: "label" }, "Viewing:"),
                        react_1.default.createElement(react_select_1.default, { className: "viewing-list", value: getSelectedViewing(), onChange: this.handleViewingChange, options: viewingOptions }))),
            newPackagesCount > 0 && this.state.selectedWorkgroup === '' &&
                react_1.default.createElement("div", { id: "new-packages-header", className: "level" },
                    react_1.default.createElement("div", { className: "level-left" },
                        react_1.default.createElement("div", { className: "level-item" },
                            react_1.default.createElement(PackageSearchInput_1.PackageSearchInput, { onChange: this.handleSearchInputChange, placeholder: 'Search Inbox...', value: this.state.searchTerm }))),
                    react_1.default.createElement("div", { className: "level-right" },
                        react_1.default.createElement("div", { className: "level-item" },
                            react_1.default.createElement("div", { className: "filter-tabs field has-addons" },
                                react_1.default.createElement("p", { className: "control" },
                                    react_1.default.createElement("a", { className: classnames_1.default('button', 'has-text-info', { 'is-active': (newPackagesSearchCount > 0) }, { 'is-disabled': (newPackagesSearchCount === 0) }), onClick: this.handleDismissAll },
                                        "Move all to",
                                        react_1.default.createElement("span", { className: "icon buttonIcon" },
                                            react_1.default.createElement("i", { className: "far fa-clock fa-fw" })),
                                        "History")))))),
            react_1.default.createElement(NewPackages_1.default, { downloadSizeLimitInMB: config_1.Config.HTTP_TRANSFER_MAX_PACKAGE_SIZE, pageSize: config_1.Config.DEFAULT_PAGE_SIZE, searchTerm: this.state.searchTerm, workgroupEmail: this.state.selectedWorkgroup })));
    };
    return NewPackagesPage;
}(react_1.Component));
exports.NewPackagesPage = NewPackagesPage;
var mapDispatchToProps = {
    onConfirmDismissAll: actions_1.confirmDismissAllPackages,
    onResetSort: actions_1.resetSort,
    saveSearchTerm: actions_2.saveSearchTerm
};
var mapStateToProps = function (store) {
    return {
        asperaInitializing: selectors_1.isAsperaInitializing(store),
        asperaLoaded: selectors_1.isAsperaLoaded(store),
        isResetting: store.newPackages.isResetting,
        locationAction: store.router.action,
        newPackagesCount: store.newPackages.totalCount,
        newPackagesSearchCount: store.newPackages.totalSearchCount,
        savedSearchTerm: store.packageDetails.savedSearchTerm,
        savedWorkgroupEmail: store.newPackages.savedWorkgroupEmail,
        workgroups: store.users.workgroups.filter(function (w) { return w.can_read; })
    };
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(NewPackagesPage);
